import React from 'react';
import PropTypes from 'prop-types';

import TabListItem from './TabListItem';

const TabList = (props) => {
    const {
        tabs,
        onDrop,
        className,
        onTabChange,
        itemClassName,
        selectedItemClassName,
        currentTabId,
    } = props;

    const handleClick = (tabId) => {
        if (tabId !== currentTabId) onTabChange(tabId)
    };

    const renderedTabs = Object.entries(tabs).map(([id, tab]) => {
        return (
            <TabListItem
                className={itemClassName}
                selectedItemClassName={selectedItemClassName}
                key={id}
                selected={id === currentTabId}
                label={tab.label}
                dropId={tab.dropId}
                onClick={handleClick.bind(this, id)}
                onDrop={onDrop}
            />
        );
    });

    return (
        <div
            className={className}
        >
            {renderedTabs}
        </div>
    );
};

TabList.propTypes = {
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    selectedItemClassName: PropTypes.string,

    tabs: PropTypes.object.isRequired,
    currentTabId: PropTypes.string.isRequired,
    onTabChange: PropTypes.func.isRequired,
    onDrop: PropTypes.func,
};

TabList.defaultProps = {
    className: '',
    itemClassName: '',
    selectedItemClassName: '',
    onDrop: null,
};

export default TabList;



// WEBPACK FOOTER //
// ./src/components/controls/TabContainer/TabList.jsx